import {get, post} from './index'

export default {
    addMessage(params) {
        return post('addMessage', params)
    },
    // 获取轮播图 type = 1首页，2关于我们，3产品中心，4定制服务5资料中心6联系我们
    getBanner(params) {
        return get('getBanner', params)
    },
    //获取关于我们
    getAbout(params) {
        return get('getAbout', params)
    },
    //获取联系我们
    getContact(params) {
        return get('getContact', params)
    },
    //获取产品分类
    getProductCate(params) {
        return get('getProductCate', params)
    },
    //获取定制服务分类
    getCustomizedServicesCate(params) {
        return get('getCustomizedServicesCate', params)
    },
    //获取优品推荐分类
    getRecommendCate(params) {
        return get('getRecommendCate', params)
    },
    //获取产品列表
    getProductList(params) {
        return get('getProductList', params)
    },
    //手机获取产品列表
    getProductList2(params) {
        return get('getProductList2', params)
    },
    //获取定制服务列表
    getCustomizedServicesList(params) {
        return get('getCustomizedServicesList', params)
    },
    //获取定制服务列表
    getCustomizedServicesList2(params) {
        return get('getCustomizedServicesList2', params)
    },
    //获取优品推荐列表
    getRecommendList(params) {
        return get('getRecommendList', params)
    },
    //获取优品推荐列表
    getRecommendList2(params) {
        return get('getRecommendList2', params)
    },
    //获取产品目录
    getProductCatalog(params){
        return get('getProductCatalog', params)
    },
    //获取文献资料
    getNews(params){
        return get('getNews', params)
    },
    // 获取文献详情
    getNewsDetail(params){
        return get('getNewsDetail', params)
    },
    //获取问答
    getQuestion(params){
        return get('getQuestion', params)
    },
    //获取宠物检测
    getTesting(params){
        return get('getTesting', params)
    },
    //获取宠物检测
    getTesting2(params){
        return get('getTesting2', params)
    }
}